import { render, staticRenderFns } from "./storeDetail.vue?vue&type=template&id=3a389128&scoped=true&"
import script from "./storeDetail.vue?vue&type=script&lang=js&"
export * from "./storeDetail.vue?vue&type=script&lang=js&"
import style0 from "./storeDetail.vue?vue&type=style&index=0&id=3a389128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a389128",
  null
  
)

export default component.exports